export const buildAccessHeaders = (user, accessInfo, options = {}) => {
  const headers = {};
  if (user?.email) headers["X-User-Email"] = user.email;
  if (user?.role) headers["X-User-Role"] = user.role || "";

  const includeCust = options.includeCust !== false;
  const includeWhs = options.includeWhs !== false;
  const activeCustTokens = Array.isArray(accessInfo?.activeCustTokens) ? accessInfo.activeCustTokens : [];
  const activeWhsTokens = Array.isArray(accessInfo?.activeWhsTokens) ? accessInfo.activeWhsTokens : [];

  if (includeCust && activeCustTokens.length) {
    headers["X-Active-Cust-Tokens"] = JSON.stringify(activeCustTokens);
  }
  if (includeWhs && activeWhsTokens.length) {
    headers["X-Active-Whs-Tokens"] = JSON.stringify(activeWhsTokens);
  }
  return headers;
};
